var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBestPractices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.993 43.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-injection",
    "data-name": "Icon metro-injection",
    d: "M40.181,15a1.555,1.555,0,0,1,0,2.2l-1.1,1.1,1.1,1.1a3.115,3.115,0,0,1,0,4.4L23.669,40.318a3.112,3.112,0,0,1-4.4,0l-1.1-1.1-4.4,4.405,2.2,2.2a1.556,1.556,0,0,1-2.2,2.2L4.953,39.215a1.556,1.556,0,0,1,2.2-2.2l2.2,2.2,4.4-4.4-1.1-1.1a3.11,3.11,0,0,1,0-4.4L29.172,12.8a3.11,3.11,0,0,1,4.4,0l1.1,1.1,1.1-1.1a1.555,1.555,0,0,1,2.2,0l.551.551,8.808-8.808v2.2l-7.706,7.706.551.552Zm-7.706-1.1a1.555,1.555,0,0,0-2.2,0l-3.3,3.3,2.2,2.2-1.1,1.1-2.2-2.2-3.3,3.3,2.2,2.2-1.1,1.1-2.2-2.2-1.1,1.1,4.4,4.4-1.1,1.1-4.4-4.4-3.3,3.3,4.4,4.4-1.1,1.1-4.4-4.4-1.1,1.1a1.555,1.555,0,0,0,0,2.2l6.605,6.605a1.554,1.554,0,0,0,2.2,0L39.078,22.708a1.552,1.552,0,0,0,0-2.2Zm-4.4,2.2,1.1-1.1,4.4,4.4-1.1,1.1Zm0,8.806-4.4-4.4,1.1-1.1,4.4,4.4Zm-11.009,2.2,1.1-1.1,2.2,2.2-1.1,1.1ZM49.491,15.29a2.113,2.113,0,0,1-4.227,0c0-1.169,2.114-4.36,2.114-4.36S49.491,14.122,49.491,15.29Z",
    transform: "translate(-4.498 -4.542)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestPractices);
export default __webpack_public_path__ + "static/media/best_practices.de1ff5eafbf0e7d5bd40bcb5eaddaff4.svg";
export { ForwardRef as ReactComponent };